/* ThreadPoint Exit-Intent Deliverability Banner v1 */
(function(){
  var COOKIE_KEY='tp_exit_seen';
  var COOKIE_DAYS=3;
  var SCROLL_TRIGGER=0.35;
  var DELAY_MS=4000;
  var DELIV_PATH='/pages/deliverability';

  if(window.location.pathname.indexOf(DELIV_PATH)===0)return;
  if(window.Shopify&&window.Shopify.designMode)return;

  function getCookie(k){var m=document.cookie.match(new RegExp('(?:^|;\\s*)'+k+'=([^;]*)'));return m?m[1]:null;}
  function setCookie(k,v,d){var dt=new Date();dt.setTime(dt.getTime()+d*864e5);document.cookie=k+'='+v+';expires='+dt.toUTCString()+';path=/;SameSite=Lax';}

  if(getCookie(COOKIE_KEY))return;

  /* inject CSS */
  var css=document.createElement('style');
  css.textContent=`
    .tp-exit-overlay{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:1.5rem;opacity:0;transition:opacity .35s ease}
    .tp-exit-overlay.tp-visible{opacity:1}
    .tp-exit-backdrop{position:absolute;inset:0;background:rgba(10,10,14,0.82);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}
    .tp-exit-modal{position:relative;background:#1A1A20;border:1px solid rgba(246,244,236,0.1);border-radius:12px;padding:3rem 2.5rem 2.5rem;max-width:520px;width:100%;text-align:center;box-shadow:0 40px 80px rgba(0,0,0,.6),0 0 0 1px rgba(232,196,65,.08);transform:translateY(20px) scale(0.97);transition:transform .4s cubic-bezier(.22,1,.36,1);background-image:repeating-linear-gradient(-55deg,transparent 0,transparent 38px,rgba(255,255,255,0.015) 38px,rgba(255,255,255,0.015) 40px)}
    .tp-exit-overlay.tp-visible .tp-exit-modal{transform:translateY(0) scale(1)}
    .tp-exit-close{position:absolute;top:1rem;right:1rem;background:none;border:1px solid rgba(246,244,236,0.1);border-radius:6px;color:rgba(246,244,236,0.45);font-size:1.5rem;width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:color .2s,border-color .2s,background .2s;line-height:1}
    .tp-exit-close:hover{color:#F6F4EC;border-color:rgba(246,244,236,0.25);background:rgba(246,244,236,0.04)}
    .tp-exit-icon{margin-bottom:1.2rem}
    .tp-exit-eyebrow{font-family:'Outfit',sans-serif;font-size:0.7rem;font-weight:700;letter-spacing:0.14em;text-transform:uppercase;color:#E8C441;margin-bottom:1rem}
    .tp-exit-heading{font-family:'Outfit',sans-serif;font-weight:800;font-size:clamp(1.5rem,4vw,1.9rem);line-height:1.15;letter-spacing:-0.015em;color:#F6F4EC;margin:0 0 1rem}
    .tp-exit-sub{font-family:'Plus Jakarta Sans',sans-serif;font-size:0.92rem;line-height:1.7;color:rgba(246,244,236,0.55);margin:0 auto 1.8rem;max-width:420px}
    .tp-exit-cta{display:inline-block;background:#E8C441;color:#1A1A20;padding:0.95rem 2.4rem;border-radius:4px;font-family:'Outfit',sans-serif;font-size:0.85rem;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;text-decoration:none;transition:opacity .2s,transform .2s}
    .tp-exit-cta:hover{opacity:0.85;transform:translateY(-2px)}
    .tp-exit-note{font-family:'Plus Jakarta Sans',sans-serif;font-size:0.72rem;color:rgba(246,244,236,0.3);margin-top:1rem}
    @media(max-width:600px){.tp-exit-modal{padding:2.5rem 1.5rem 2rem;border-radius:10px}.tp-exit-icon svg{width:40px;height:40px}.tp-exit-cta{width:100%;text-align:center;padding:1rem 1.5rem}}
  `;
  document.head.appendChild(css);

  /* inject HTML */
  var div=document.createElement('div');
  div.id='tp-exit-overlay';
  div.className='tp-exit-overlay';
  div.setAttribute('aria-hidden','true');
  div.innerHTML=`
    <div class="tp-exit-backdrop"></div>
    <div class="tp-exit-modal" role="dialog" aria-labelledby="tp-exit-heading">
      <button class="tp-exit-close" aria-label="Close">&times;</button>
      <div class="tp-exit-icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="4" y="12" width="40" height="26" rx="3" stroke="#E8C441" stroke-width="2.5"/><path d="M4 15l20 13 20-13" stroke="#E8C441" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M32 6l-8 6-8-6" stroke="#E8C441" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity=".5"/></svg>
      </div>
      <p class="tp-exit-eyebrow">\u2726 Free in 5 Minutes</p>
      <h2 id="tp-exit-heading" class="tp-exit-heading">Get a Free Deliverability Code, Tested in 5 Minutes</h2>
      <p class="tp-exit-sub">Test our proprietary code that moves emails from the promotions tab to your customers\u2019 inbox, risk-free with a simple A/B test we will set up for you in 5 minutes.</p>
      <a href="/pages/deliverability" class="tp-exit-cta">Get Your Free Code \u2192</a>
      <p class="tp-exit-note">No commitment. No credit card. Just results.</p>
    </div>
  `;
  /* div appended on first show only */

  var overlay=div;
  var shown=false;
  var ready=false;

  setTimeout(function(){ready=true;},DELAY_MS);

  function showBanner(){
    if(shown||!ready)return;
    shown=true;
    document.body.appendChild(div);
    overlay.setAttribute('aria-hidden','false');
    void overlay.offsetHeight;
    overlay.classList.add('tp-visible');
    document.body.style.overflow='hidden';
  }

  function dismiss(){
    overlay.classList.remove('tp-visible');
    setTimeout(function(){
      overlay.remove();
      document.body.style.overflow='';
    },350);
    setCookie(COOKIE_KEY,'1',COOKIE_DAYS);
  }

  /* close button */
  overlay.querySelector('.tp-exit-close').addEventListener('click',dismiss);
  /* backdrop click */
  overlay.querySelector('.tp-exit-backdrop').addEventListener('click',dismiss);
  /* CTA click also sets cookie */
  overlay.querySelector('.tp-exit-cta').addEventListener('click',function(){setCookie(COOKIE_KEY,'1',COOKIE_DAYS);if(typeof gtag==='function'){gtag('event','popup_cta_click',{event_category:'engagement',event_label:'deliverability_exit_intent'});}});
  /* escape key */
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&shown)dismiss();});

  /* desktop: mouse leaves viewport top */
  document.addEventListener('mouseout',function(e){
    if(e.clientY<=0&&!e.relatedTarget&&!e.toElement)showBanner();
  });

  /* mobile: scroll up quickly after scrolling past threshold */
  var lastY=0,hitThreshold=false;
  window.addEventListener('scroll',function(){
    var y=window.scrollY||window.pageYOffset;
    var docH=document.documentElement.scrollHeight-window.innerHeight;
    if(docH>0&&y/docH>SCROLL_TRIGGER)hitThreshold=true;
    if(hitThreshold&&y<lastY-120)showBanner();
    lastY=y;
  },{passive:true});
})();
